import { HttpError, isHttpError } from '@/http';

/**
 * True when the server answered with a 4xx status (e.g. a wrong OTP).
 * Network failures and 5xx responses are not client errors.
 */
export function isClientHttpError(error: unknown): error is HttpError {
	return (
		isHttpError(error) &&
		error.status !== undefined &&
		error.status >= 400 &&
		error.status < 500
	);
}
